/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Adjustments_Page_DescriptionInputs */

const en_shipping_adjustments_page_description = /** @type {(inputs: Shipping_Adjustments_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage shipping cost corrections and adjustments`)
};

const es_shipping_adjustments_page_description = /** @type {(inputs: Shipping_Adjustments_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administra correcciones y ajustes de costos de envio`)
};

/**
* | output |
* | --- |
* | "Manage shipping cost corrections and adjustments" |
*
* @param {Shipping_Adjustments_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const shipping_adjustments_page_description = /** @type {((inputs?: Shipping_Adjustments_Page_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Adjustments_Page_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_adjustments_page_description(inputs)
	return es_shipping_adjustments_page_description(inputs)
});